import { api } from "./api.ts";

type GetReportsArgs = {
  searchTerm?: string;
  filters?: Record<string, unknown>;
};

type GetReportByIdArgs = {
  reportId: string | number;
};

export const reportingAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getReports: build.query<unknown, GetReportsArgs>({
      query: ({ searchTerm, filters = {} }) => ({
        url: `api/v1/reports/`,
        method: "GET",
        params: searchTerm
          ? { filter: searchTerm, ...filters }
          : { ...filters },
      }),
    }),
    getReportById: build.mutation<unknown, GetReportByIdArgs>({
      query: ({ reportId }) => ({
        url: `api/v1/reports/${reportId}/`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetReportsQuery, useGetReportByIdMutation } = reportingAPI;
